// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase-guide-page .guide-container {
  max-width: 900px;
}

/* Larger text for readability */
.purchase-guide-page .guide-section p,
.purchase-guide-page .guide-list li,
.purchase-guide-page .guide-steps li {
  font-size: 0.95rem;
  line-height: 1.7;
}

.purchase-guide-page .guide-section h2 {
  font-size: 1.35rem;
}

.purchase-guide-page .guide-section h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0.5rem 0 0.75rem;
}

.guide-lead {
  font-size: 1.05rem !important;
  color: var(--text-primary) !important;
  font-weight: 500;
}

/* Section header with icon */
.guide-section-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.75rem;
}

.guide-section-header h2 {
  margin: 0 !important;
}

.guide-section-icon {
  font-size: 1.4rem;
  flex-shrink: 0;
}

/* Accent stripes */
.guide-section-accent-blue {
  border-top: 3px solid var(--accent-primary);
}

.guide-section-accent-gold {
  border-top: 3px solid #d4a017;
}

/* Troubleshoot sections */
.guide-section-troubleshoot {
  border-left: 3px solid var(--warning);
  background: var(--bg-secondary);
}

.guide-section-troubleshoot .guide-section-header h2 {
  font-size: 1.15rem;
}

/* Callout boxes */
.guide-callout {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  margin-top: 0.75rem;
}

.guide-callout-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
  line-height: 1.6;
}

.guide-callout p {
  margin: 0 !important;
  font-size: 0.9rem !important;
  line-height: 1.6;
}

.guide-callout-warning {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  color: var(--text-primary);
}

.guide-callout-info {
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.2);
  color: var(--text-primary);
}

/* Comparison cards (Elite vs VX) */
.guide-comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 1rem;
}

.guide-comparison-card {
  background: var(--bg-primary);
  border-radius: 10px;
  padding: 1.25rem;
  border: 1px solid var(--border-primary);
}

.guide-comparison-card h3 {
  margin: 0 0 0.75rem !important;
}

.guide-card-elite {
  border-top: 3px solid #d4a017;
}

.guide-card-vx {
  border-top: 3px solid var(--accent-primary);
}

.guide-comparison-card .guide-list {
  margin-bottom: 0.5rem;
}

/* Hint link */
.guide-hint {
  margin-top: 0.75rem !important;
  font-size: 0.95rem !important;
}

.guide-hint .guide-inline-link {
  font-weight: 600;
}

/* Responsive */
@media (max-width: 680px) {
  .guide-comparison {
    grid-template-columns: 1fr;
  }

  .purchase-guide-page .guide-section p,
  .purchase-guide-page .guide-list li,
  .purchase-guide-page .guide-steps li {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/guides/PurchaseGuidePage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":[".purchase-guide-page .guide-container {\r\n  max-width: 900px;\r\n}\r\n\r\n/* Larger text for readability */\r\n.purchase-guide-page .guide-section p,\r\n.purchase-guide-page .guide-list li,\r\n.purchase-guide-page .guide-steps li {\r\n  font-size: 0.95rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n.purchase-guide-page .guide-section h2 {\r\n  font-size: 1.35rem;\r\n}\r\n\r\n.purchase-guide-page .guide-section h3 {\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0.5rem 0 0.75rem;\r\n}\r\n\r\n.guide-lead {\r\n  font-size: 1.05rem !important;\r\n  color: var(--text-primary) !important;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Section header with icon */\r\n.guide-section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.guide-section-header h2 {\r\n  margin: 0 !important;\r\n}\r\n\r\n.guide-section-icon {\r\n  font-size: 1.4rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Accent stripes */\r\n.guide-section-accent-blue {\r\n  border-top: 3px solid var(--accent-primary);\r\n}\r\n\r\n.guide-section-accent-gold {\r\n  border-top: 3px solid #d4a017;\r\n}\r\n\r\n/* Troubleshoot sections */\r\n.guide-section-troubleshoot {\r\n  border-left: 3px solid var(--warning);\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.guide-section-troubleshoot .guide-section-header h2 {\r\n  font-size: 1.15rem;\r\n}\r\n\r\n/* Callout boxes */\r\n.guide-callout {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  padding: 0.85rem 1rem;\r\n  border-radius: 8px;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.guide-callout-icon {\r\n  font-size: 1.2rem;\r\n  flex-shrink: 0;\r\n  line-height: 1.6;\r\n}\r\n\r\n.guide-callout p {\r\n  margin: 0 !important;\r\n  font-size: 0.9rem !important;\r\n  line-height: 1.6;\r\n}\r\n\r\n.guide-callout-warning {\r\n  background: rgba(245, 158, 11, 0.1);\r\n  border: 1px solid rgba(245, 158, 11, 0.25);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.guide-callout-info {\r\n  background: rgba(59, 130, 246, 0.08);\r\n  border: 1px solid rgba(59, 130, 246, 0.2);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Comparison cards (Elite vs VX) */\r\n.guide-comparison {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.guide-comparison-card {\r\n  background: var(--bg-primary);\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  border: 1px solid var(--border-primary);\r\n}\r\n\r\n.guide-comparison-card h3 {\r\n  margin: 0 0 0.75rem !important;\r\n}\r\n\r\n.guide-card-elite {\r\n  border-top: 3px solid #d4a017;\r\n}\r\n\r\n.guide-card-vx {\r\n  border-top: 3px solid var(--accent-primary);\r\n}\r\n\r\n.guide-comparison-card .guide-list {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n/* Hint link */\r\n.guide-hint {\r\n  margin-top: 0.75rem !important;\r\n  font-size: 0.95rem !important;\r\n}\r\n\r\n.guide-hint .guide-inline-link {\r\n  font-weight: 600;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 680px) {\r\n  .guide-comparison {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .purchase-guide-page .guide-section p,\r\n  .purchase-guide-page .guide-list li,\r\n  .purchase-guide-page .guide-steps li {\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
